import React from "react";
import { MultiValue, Select } from "chakra-react-select";
import { ValueEditorProps } from "react-querybuilder";
import { SystemStyleObject } from "@chakra-ui/react";
import colors from "app/colors";

interface OptionType {
  value: string;
  label: string;
  active: boolean;
  isDisabled: boolean;
}

const QueryValueSelector: React.FC<ValueEditorProps> = ({
  value,
  handleOnChange,
  values,
  className,
}) => {
  if (!values) return null;

  const options: OptionType[] = values.map((v) => ({
    value: v.value,
    label: v.label,
    active: v.active,
    isDisabled: !v.active,
  }));

  const selectedOptions: OptionType[] = Array.isArray(value)
    ? value
        .map((val: string) => options.find((opt) => opt.value === val))
        .filter((opt): opt is OptionType => !!opt)
    : [];

  const onChange = (selected: MultiValue<OptionType>) => {
    const selectedValues = selected.map((s) => s.value);
    handleOnChange(selectedValues);
  };

  return (
    <Select<OptionType, true>
      className={className}
      options={options}
      value={selectedOptions}
      onChange={onChange}
      isMulti
      isClearable
      placeholder="Select value(s)..."
      components={{
        DropdownIndicator: () => null,
        IndicatorSeparator: () => null,
      }}
      chakraStyles={{
        container: (provided: SystemStyleObject): SystemStyleObject => ({
          ...provided,
          width: "100%",
        }),
        valueContainer: (provided: SystemStyleObject): SystemStyleObject => ({
          ...provided,
          bg: colors.white,
        }),
        control: (provided: SystemStyleObject): SystemStyleObject => ({
          ...provided,
          bg: colors.white,
        }),
        placeholder: (provided) => ({
          ...provided,
          fontSize: "14px",
        }),
        option: (provided) => ({
          ...provided,
          fontSize: "14px",
        }),
        multiValue: (
          provided: SystemStyleObject,
          state,
        ): SystemStyleObject => ({
          ...provided,
          borderRadius: "full",
          borderWidth: "1px",
          borderColor: state.data.active ? colors.blue : colors.gray30,
          backgroundColor: colors.white,
          color: state.data.active ? colors.blue : colors.gray30,
          fontSize: 14,
          fontStyle: state.data.active ? "normal" : "italic",
        }),
      }}
    />
  );
};

export default QueryValueSelector;
